const getDomainFromUrl = () => {
    const location = window.location.href;
    const position = location.search('name');
    const subStr = location.substring(position);
    const domainPosition = subStr.search('=');
    const domain = subStr.substring(domainPosition + 1).split('&')[0];
    return domain;
};

export { getDomainFromUrl }